import { WithdrawalMethodId, WithdrawalReq } from '../entities';

export const withdrawalReqMock: WithdrawalReq = {
  amount: 100,
  fromAccountId: 'account-1',
  method: WithdrawalMethodId.Paypal,
  details: {
    email: 'test@test.test',
  },
  requestId: '123',
  targetCurrencyId: 'account-1',
  description: '',
  targetCryptoAddress: '',
};
